  <div class="inline-message error" >
  <mat-icon class="inline-message-icon" color="error">
    error
  </mat-icon>
  <div class="inline-message-content">
    <div class="title">Page not found.</div>
    <div class="description">Unable to load the requested page due to server error. Click the back button of the browser and try again.</div>
  </div>
</div>
